import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';

//export columns for the route
export const exportColumns = (t) => {
  return [
    { fieldName: 'id', fieldTitle: t('Κωδικός Περιφερειακής Ενότητας'), fieldType: 'TEXT' },
    { fieldName: 'name', fieldTitle: t('Όνομα Περιφερειακής Ενότητας'), fieldType: 'TEXT' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetQuery, {
      onCompleted: transformData,
      fetchPolicy: 'network-only',
    });

    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);

    function transformData(data) {
      console.log('Apollo result:', data);

      const recs = data.getSubregions.data.map((values) => ({
        ...values,
      }));

      const trsData = {
        getSubregions: {
          data: recs,
          recordCount: data?.getSubregions?.recordCount,
        },
      };

      setResult([get, { loading, data: trsData }]);
    }

    return result;
  }

  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };

  await exportXlsModal({
    apolloClient: client,
    exportFileName: t('export Subregions'),
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}
